import React from 'react'

import Header from '../../../components/header'
import * as S from './styles'

const ConfirmAccount = () => (
  <S.Container>
    <Header title="Confirmação de conta" />
    <div>
      <h5>
        Conta confirmada com sucesso.
        {' '}
        <br />
        Você será redirecionado para a tela de login em instantes!
      </h5>
    </div>
  </S.Container>
)

export default ConfirmAccount
